/** Regras puras do guarda-roupa no cliente (techspec-guardaroupa). Sem React — os testes importam direto. */

export const TINTA_PRIME = 'tinta-prime-';
/** A tinta comum de uma cor básica trancada (Renato, 21/10): `tinta-vermelho`. Cai do Baú do Balron. */
export const TINTA_BASICA = 'tinta-';

/** A cor da tinta (`tinta-prime-fogo` → `fogo`, `tinta-vermelho` → `vermelho`), ou null se o item não é tinta. */
export function corDaTinta(defId: string | null | undefined): string | null {
  const id = (defId ?? '').trim();
  const cor = id.startsWith(TINTA_PRIME) ? id.slice(TINTA_PRIME.length)
    : id.startsWith(TINTA_BASICA) ? id.slice(TINTA_BASICA.length) : '';
  return /^[a-z]{2,24}$/.test(cor) ? cor : null;
}

/** O item da tinta de uma cor: a prime tem o prefixo `tinta-prime-`, a básica só `tinta-`. */
export function itemDaTinta(cor: string, prime: boolean): string {
  return (prime ? TINTA_PRIME : TINTA_BASICA) + cor;
}

/** O item da skin extraída (techspec-skins §06): `skin-natal-gorro`. */
export const PREFIXO_SKIN = 'skin-';

/** A skin do item (`skin-natal-gorro` → `natal-gorro`), ou null se o item não é skin. */
export function skinDoItem(defId: string | null | undefined): string | null {
  const id = (defId ?? '').trim();
  if (!id.startsWith(PREFIXO_SKIN)) return null;
  const peca = id.slice(PREFIXO_SKIN.length);
  return /^[a-z0-9]+(-[a-z0-9]+)+$/.test(peca) && peca.length <= 44 ? peca : null;
}

/** A cor da raridade (o brilho da célula e o contorno da joia). */
export const COR_DA_RARIDADE: Readonly<Record<string, string>> = {
  comum: '#b9b2a4',
  rara: '#5b9ee6',
  epica: '#b072ea',
  lendaria: '#eaa13a'
};

/** As 8 direções do provador, a partir de "de frente" (a direção 1 do motor), girando para a direita. */
export const DIRECOES_DO_PROVADOR = [1, 2, 3, 4, 5, 6, 7, 0] as const;

/** Da mais comum para a mais rara (Renato, 25/10/2026): a ordem das listas de tintas e de skins. */
export const ORDEM_DA_RARIDADE: readonly string[] = ['comum', 'rara', 'epica', 'lendaria'];

/**
 * A raridade de cada set de skin, só para ordenar a lista (a skin não tem raridade própria): o Natal é de evento,
 * Morte e Pentagrama saem de chefe e ritual, Fundador e GM ninguém mais consegue. Set novo sem entrada aqui vai para
 * o começo, como comum.
 */
export const RARIDADE_DO_SET: Readonly<Record<string, string>> = {
  natal: 'rara',
  morte: 'epica',
  pentagrama: 'epica',
  fundador: 'lendaria',
  gm: 'lendaria'
};

/** 0 (comum) a 3 (lendária); sem raridade conta como comum. */
export function nivelDaRaridade(raridade: string | null | undefined): number {
  const i = ORDEM_DA_RARIDADE.indexOf(raridade ?? 'comum');
  return i < 0 ? 0 : i;
}

/** Cópia ordenada da mais comum para a mais rara; a ordem de origem fica dentro de cada raridade. */
export function porRaridade<T>(lista: readonly T[], raridade: (x: T) => string | null | undefined): T[] {
  return lista
    .map((x, i) => ({ x, i, n: nivelDaRaridade(raridade(x)) }))
    .sort((a, b) => a.n - b.n || a.i - b.i)
    .map(e => e.x);
}
